import { render, staticRenderFns } from "./GroupIcon.vue?vue&type=template&id=f9f7d888&scoped=true&"
import script from "./GroupIcon.vue?vue&type=script&lang=ts&"
export * from "./GroupIcon.vue?vue&type=script&lang=ts&"
import style0 from "./GroupIcon.vue?vue&type=style&index=0&id=f9f7d888&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9f7d888",
  null
  
)

export default component.exports